var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.translations.labels.footer)+" "),_vm._m(0)])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('a',{attrs:{"href":"mailto:support@e-screen.app"}},[_vm._v("support@e-screen.app")])])
}]

export { render, staticRenderFns }